export default __webpack_public_path__ + "static/media/ic-structure-2.9e57bc18.svg";